const queryKeys = {
  loginOptions: 'login-options',
}

export default queryKeys
